export default __webpack_public_path__ + "static/media/plotly.ffb89e34.svg";